export const badgeMileage = 'https://cf.image-farm.s.zigzag.kr/original/cms/2024/03/27/202403270143144807_039942.webp';

export const badgePoint = 'https://cf.image-farm.s.zigzag.kr/original/cms/2024/04/24/202404240654278247_087716.webp';
